
export default {
    install(Vue) {
        //时间戳转换为时间 format('yyyy-MM-dd hh:mm:ss')
        Vue.prototype.formatTime = function (value, format) {
            if (typeof (value) == 'undefined') {
                return ''
            } else {
                let date = new Date(parseInt(value))
                let y = date.getFullYear()
                let MM = date.getMonth() + 1
                MM = MM < 10 ? ('0' + MM) : MM
                let d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                let h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                let m = date.getMinutes()
                m = m < 10 ? ('0' + m) : m
                let s = date.getSeconds()
                s = s < 10 ? ('0' + s) : s
                return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
            }
        }

        //时间戳转换为时间 format('yyyy-MM-dd hh:mm:ss')
        Vue.filter("format", function (value, format) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            return Vue.prototype.formatTime(value, format);
        });
        //日期转换
        Vue.prototype.transformTime = function (myDate) {
            if (myDate == "" || myDate == undefined) {
                return ''
            } else {
                var month = myDate.getMonth() + 1;
                var Day = myDate.getDate();
                var date = "";
                if (month < 10) {
                    if (Day < 10) {
                        date = myDate.getFullYear() + "-0" + month + "-0" + Day;
                    } else {
                        date = myDate.getFullYear() + "-0" + month + "-" + Day;
                    }
                } else {
                    if (Day < 10) {
                        date = myDate.getFullYear() + "-" + month + "-0" + Day;
                    } else {
                        date = myDate.getFullYear() + "-" + month + "-" + Day;
                    }
                }
                return date;
            }
        },
            //JSEncrypt加密
            Vue.prototype.encrypt = function (value) {
                // 实例化一个JSEncrypt对象
                let jse = new this.$jsEncrypt()
                jse.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCsuFef2IzT2GXL6WICnaUrtgjLQM/ZlI9K63c68alSQLZODjHYeSzjUlTZiZILvM2jurbFOMM9/vBJjWxg0m/zynSCYoBFF4xdVkWkwfmx+hahkMGHQcODjERh5nRmNDc00/pLYYSsoXMok+RXUV7Q3fji1JN/0uoM99TjHfasUQIDAQAB')
                // 设置需要加密的字符串
                let encrypted = jse.encrypt(value)
                // 输出加密结果
                return encrypted;
            }
        //解密
        Vue.prototype.decrypt = function (value) {
            let decrypt = new this.$jsEncrypt()
            decrypt.setPrivateKey('MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAKy4V5/YjNPYZcvpYgKdpSu2CMtAz9mUj0rrdzrxqVJAtk4OMdh5LONSVNmJkgu8zaO6tsU4wz3+8EmNbGDSb/PKdIJigEUXjF1WRaTB+bH6FqGQwYdBw4OMRGHmdGY0NzTT+kthhKyhcyiT5FdRXtDd+OLUk3/S6gz31OMd9qxRAgMBAAECgYBjrad0KodroxFsku3rUIuIJHACzQ6nJSNlO2r964WqYIpVlb+SjKwpLNSnDsvoVjffa9wbCd0zpDOMXz/SyN+uPpwr8SU6eCtXb3dD6aJc4/NJWlgSdRAzROJklE5kGblQmOrPYI/xfotnmOKcbVvuA2HN6sfDMXainhZGcq+FmQJBAPdCYjISvcpLOu8RXq1c4HyjM1/KydKJ+TrlrzlUZnlL/DhOMoXa0HL+qDLYExk5W8H2EoSZRlD4IDwcgTWVMjMCQQCy02cnvh4Rh7FBL/Iy1stNLSoB5jSs0Giyqc4tzVM9XcGdjtPx6NkJnVQR+fEg+1/4GSsPpr3Wgy1eNqchQ4trAkAcYBjmyDHRolqMDwE/gfYdN5lwt9P7fmwEr1ExkhcEeoziZU70/4yGdeUVmKhwb52xH602XGSubBs+6sKFRK7zAkA3PmPBvVPgqoCx2LQDzKNlpiwyBgID2SZe+2I8eA/dB1fG6tbDBuH1vGq6WvKI899D79KDtUk0ObYMQuoCtrEdAkEA7ZaLQ6WT/gKE5TABGxU+ffyaBa/iFHGNT0mOL+lrwSuT7AmDu3rfKl0dne2vnGsZ84VEWJob1ssNusH8voSDpg==')
            let decryptMsg = decrypt.decrypt(value)
            return decryptMsg
        }
        //是否包含特殊字符
        Vue.prototype.containSpecial = function (value) {
            let containSpecial = RegExp(
                /[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\_)(\&)(\*)(\()(\))(\-)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/
            );
            return containSpecial.test(value);
        }
        //是否只有汉字
        Vue.prototype.checkChinese = function (value) {
            let myReg = /^[\u4e00-\u9fa5]+$/;
            return myReg.test(value);
        }
        //日期转时间戳
        Vue.prototype.dateToTimestamp = function (dateStr) {
            if(dateStr=="")return;
            var timestamp2 = dateStr.replace(/-/g, '/')   //为了兼容IOS，需先将字符串转换为'2018/9/11 9:11:23'
            timestamp2 = Date.parse(timestamp2)    //返回'2018-9-12 9:11:23'的时间戳
            return timestamp2;
        }
    }
}



// WEBPACK FOOTER //
// ./src/config/filter.js